<template>
  <div>
    <el-dialog
      class="modal"
      title="創建子帳號"
      :visible.sync="createSubModal"
      width="375px"
    >
      <el-dialog
        width="375px"
        title="子帳號"
        :visible.sync="createSubInner"
        append-to-body
      >
        <p class="text-danger">請先設置權限!</p>
        <p>後台登入位置:{{ location() }}/login</p>
        <p>登入帳號:{{ currentData.username }}</p>
        <p>登入密碼:{{ currentData.password }}</p>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="createSubInner = false" class="oBtn">關閉</div>
        </div>
      </el-dialog>
      <el-form :model="createSubData" label-position="top">
        <el-form-item label="帳號" label-width="80px">
          <el-input
            v-model="createSubData.username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="名稱" label-width="80px">
          <el-input v-model="createSubData.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="createSubModal = false" class="btn">關閉</div>
        <div @click="confirmCreateSub" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯用戶白名單"
      :visible.sync="editIPModal"
      width="375px"
    >
      <p class="text-danger" style="text-align:center">換行做分隔</p>
      <el-form :model="currentData" label-position="top" v-if="editIPModal">
        <el-form-item label="用戶登入IP白名單">
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[0].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="提現IP白名單">
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[1].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="代付IP設定">
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[2].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="驗證碼">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editIPModal = false" class="btn">關閉</div>
        <div @click="confirmEditIP" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯用戶"
      :visible.sync="editUserModal"
      width="80%"
    >
      <p style="text-align:center">用戶 {{ currentData.id }}</p>
      <el-tabs v-model="activeName" v-if="editUserModal">
        <el-tab-pane label="基本資料" name="1">
          <el-form inline :model="currentData" label-position="top">
            <el-form-item label="用戶號" label-width="80px">
              <el-input
                disabled
                v-model="currentData.id"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="用戶類型" label-width="80px">
              <el-input
                disabled
                v-model="currentData.role_name_ch"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="用戶名稱" label-width="80px">
              <el-input
                v-model="currentData.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="系統費"
              label-width="80px"
              v-if="currentData.agent"
            >
              <el-input
                v-model="currentData.agent.system_rate"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="手機號碼" label-width="80px">
              <el-input
                v-model="currentData.phone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="電子信箱" label-width="80px">
              <el-input
                v-model="currentData.email"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editUserModal = false" class="btn">關閉</div>
        <div @click="confirmEditUser" class="btn">確定</div>
      </div>
    </el-dialog>

    <el-dialog
      class="modal"
      title="修改密碼"
      :visible.sync="editPasswordModal"
      width="375px"
    >
      <el-form :model="editPasswordData" label-position="top">
        <el-form-item label="密碼" label-width="80px">
          <el-input
            v-model="editPasswordData.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="提款密碼" label-width="80px">
          <el-input
            v-model="editPasswordData.withdraw_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="2FA驗證碼" label-width="80px">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editPasswordModal = false" class="btn">關閉</div>
        <div @click="confirmEditPassword" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="重設2FA"
      :visible.sync="reset2FAModal"
      width="375px"
    >
      <div>確認重設 {{ currentData.id }} 2FA?</div>
      <el-form :model="currentData" label-position="top">
        <el-form-item label="驗證碼" label-width="80px">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="reset2FAModal = false" class="btn">取消</div>
        <div @click="confirmReset2FA" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      :title="'修改' + switchData.editTitle"
      :visible.sync="editSwitchModal"
      width="375px"
    >
      <div>
        確認{{ currentData[currentData.assign] == 1 ? "關閉" : "開啟" }}
        {{ currentData.id }} ?
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editSwitchModal = false" class="btn">取消</div>
        <div @click="confirmEditSwitch" class="btn">確認</div>
      </div>
    </el-dialog>
    <div v-if="!authList">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <el-form-item label="商戶號/用戶名">
          <el-input
            v-model="searchData.user_id_name"
            placeholder="商戶號/用戶名"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="用戶類型">
          <el-select v-model="searchData.role_name" placeholder="用戶類型">
            <el-option label="全部" value=""></el-option>
            <el-option label="商戶" value="customer"></el-option>
            <el-option label="一般代理" value="subagent"></el-option>
            <el-option label="高級代理" value="agent"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              inSearch = true;
              saveData = false;
              getData();
            "
            >搜尋</el-button
          >
        </el-form-item>
      </el-form>

      <el-button size="mini" class="btn btn-green ml-1" @click="createSub">
        創建子帳號
      </el-button>
      <el-table
        stripe
        :data="dataList"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column
          :min-width="100"
          :key="1"
          header-align="center"
          align="center"
          prop="id"
          label="ID"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          :key="2"
          header-align="center"
          align="center"
          prop="role_name_ch"
          label="用戶類型"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          :key="3"
          header-align="center"
          align="center"
          prop="username"
          label="用戶帳號"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          :key="4"
          header-align="center"
          align="center"
          prop="name"
          label="用戶名稱"
        >
        </el-table-column>
        <el-table-column
          :min-width="100"
          :key="9"
          header-align="center"
          align="center"
          prop="type_ch"
          label="啟用狀態"
        >
          <template slot-scope="scope">
            <div>
              <el-switch
                :value="scope.row.status == 1"
                @change="
                  changeSwitch(
                    scope.row,
                    'status',
                    '啟用狀態',
                    `/back/users/${scope.row.id}/enable`
                  )
                "
                active-color="#13ce66"
                inactive-color="#ff4949"
                v-if="$permission('users.list.enable')"
              >
              </el-switch>
              <p v-else>
                {{ scope.row.status == 1 ? "開啟" : "關閉" }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :key="8"
          header-align="center"
          align="center"
          prop="type_ch"
          label="用戶操作"
        >
          <template slot-scope="scope">
            <div style="display:flex">
              <el-button
                size="mini"
                class="btn btn-green ml-1"
                @click="editAuth(scope.row)"
              >
                權限
              </el-button>
              <el-button
                size="mini"
                v-if="$permission('users.list.update')"
                @click="editPassword(scope.row)"
              >
                修改密碼
              </el-button>
              <el-button
                size="mini"
                v-if="$permission('users.list.update')"
                @click="editUser(scope.row)"
              >
                編輯用戶
              </el-button>
              <el-button
                size="mini"
                v-if="$permission('users.list.allowedIpAddresses.store')"
                @click="editUserIP(scope.row)"
              >
                白名單
              </el-button>
              <el-button size="mini" @click="reset2FA(scope.row)"
                >重設2FA</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-count="pagination.total_page"
        >
        </el-pagination>
      </div>
    </div>
    <div v-if="authList">
      <div class="labelGroup" v-for="(data, index) in authList" :key="index">
        <div class="checkbox c-checkbox">
          <label>
            <input
              @change="allClick(data)"
              type="checkbox"
              value
              :checked="secondCheck(data)"
            />
            <!-- <span class="fa fa-check"></span> -->
            {{ data[Object.keys(data)[0]] }}
          </label>
        </div>
        <div
          class="labelChildren"
          v-for="(second, index) in data.sub"
          :key="index"
        >
          <div class="checkbox c-checkbox">
            <label>
              <input
                @change="allClick(second)"
                type="checkbox"
                value
                :checked="secondCheck(second)"
              />
              <!-- <span class="fa fa-check"></span> -->
              {{ second.name }}
            </label>
          </div>
          <div class="children">
            <div
              class="checkbox c-checkbox lastBox"
              v-for="(children, num) in second"
              :key="num"
              v-show="children != second.name"
            >
              <label>
                <input type="checkbox" v-model="children.check" value />
                <!-- <span class="fa fa-check"></span> -->
                {{ children[Object.keys(children)[0]] }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="btnGroup">
        <el-button
          style="margin-bottom:5px"
          size="mini"
          @click="authList = false"
          >上一步</el-button
        >
        <el-button
          type="primary"
          style="margin-bottom:5px"
          size="mini"
          @click="confirmEdit"
          >確認</el-button
        >
        <!-- @click="checkEditAuth" -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      authList: false,
      dataList: [],
      searchData: {},
      saveData: false,
      page: 1,
      inSearch: false,
      pagination: {},
      changeBalanceData: {},
      oneCode: "",
      currentData: {},
      switchData: {},
      editSwitchModal: false,
      reset2FAModal: false,
      editPasswordModal: false,
      editPasswordData: {},
      editUserModal: false,
      activeName: "1",
      editIPModal: false,
      createSubModal: false,
      createSubInner: false,
      createSubData: {}
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    location() {
      return location.origin;
    },
    confirmCreateSub() {
      if (!this.createSubData.username) {
        this.$message.error("請輸入帳號");
        return;
      }
      if (!this.createSubData.name) {
        this.$message.error("請輸入名稱");
        return;
      }
      this.$http.post(`/back/users/staff/sub`, this.createSubData).then(res => {
        if (res.data.code == 0) {
          this.currentData = res.data.data;
          this.createSubInner = true;
          this.createSubData = {};
        }
      });
    },
    createSub() {
      this.createSubModal = true;
      this.createSubData = {};
    },
    confirmEdit() {
      let sendData = [];
      let data = this.authList;
      Object.keys(data).forEach(e => {
        Object.keys(data[e].sub).forEach(two => {
          Object.keys(data[e].sub[two]).forEach(thr => {
            if (thr == "name") return;
            if (data[e].sub[two][thr].check) {
              sendData.push(Object.keys(data[e].sub[two][thr])[0]);
            }
          });
        });
      });
      this.$http
        .post(`/back/users/staff/sub/${this.currentData.id}`, {
          permissions: sendData
        })
        .then(res => {
          if (res.data.code == 0) {
            this.authList = false;
            this.$message.success("成功");
          }
        });
    },
    secondCheck(data) {
      let method = false;
      if (data.sub) {
        Object.keys(data.sub).forEach(one => {
          Object.keys(data.sub[one]).forEach(datas => {
            if (datas != "name") {
              if (data.sub[one][datas].check) {
                method = true;
              }
            }
          });
        });
      } else {
        Object.keys(data).forEach(datas => {
          if (datas != "name") {
            if (data[datas].check) {
              method = true;
            }
          }
        });
      }
      return method;
    },
    allClick(data) {
      if (data.sub) {
        Object.keys(data.sub).forEach(e => {
          Object.keys(data.sub[e]).forEach(datas => {
            if (datas != "name") {
              data.sub[e][datas].check = event.target.checked;
            }
          });
        });
      } else {
        Object.keys(data).forEach(datas => {
          if (datas != "name") {
            data[datas].check = event.target.checked;
          }
        });
      }
    },
    editAuth(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.$http.get(`/back/users/staff/sub/${user.id}`).then(res => {
        if (res.data.code == 0) {
          this.authList = res.data.data.permissions;
        }
      });
    },
    confirmEditIP() {
      let data = JSON.parse(JSON.stringify(this.currentData));
      data.user_id = data.id;
      let sendData = [];
      data.allowed_ips.forEach((e, index) => {
        let ips;
        ips = data.allowed_ips[index].ips.split("\n").filter(e => {
          return e != "";
        });
        sendData.push({
          user_id: data.id,
          type: e.type,
          ips
        });
      });
      this.$http
        .post(`/back/allowedIpAddresses`, {
          ips: sendData,
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.editIPModal = false;
            this.currentData = {};
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    editUserIP(user) {
      let data = JSON.parse(JSON.stringify(user));
      if (data.allowed_ips.length == 0) {
        data.allowed_ips[0] = {
          ips: "",
          type: 0
        };
        data.allowed_ips[1] = {
          ips: "",
          type: 1
        };
        data.allowed_ips[2] = {
          ips: "",
          type: 2
        };
      } else {
        data.allowed_ips.forEach(ips => {
          data.allowed_ips[ips.type].ips = data.allowed_ips[ips.type].ips
            .join()
            .replace(/,/g, "\n");
        });
      }
      this.oneCode = "";
      this.currentData = data;
      this.editIPModal = true;
    },
    confirmEditUser() {
      let data = JSON.parse(JSON.stringify(this.currentData));
      data.user_id = this.currentData.id;
      if (this.currentData.customer) {
        data.role_name = this.currentData.role_name;
        data.enable_payment_api = this.currentData.customer.enable_payment_api;
        data.payment_fee_type = this.currentData.customer.payment_fee_type;
        data.limit_enable = this.currentData.customer.limit_enable;
        if (this.currentData.customer.limit_enable == 1) {
          data.limit_decay_minutes = this.currentData.customer.limit_decay_minutes;
          data.limit_end_time =
            this.currentData.customer.limit_end_time || null;
          data.limit_max_attempts = this.currentData.customer.limit_max_attempts;
          data.limit_start_time =
            this.currentData.customer.limit_start_time || null;
        }
        if (this.currentData.customer.enable_wallet_address) {
          data.enable_wallet_address = this.currentData.customer.enable_wallet_address;
          data.wallet_notify_url = this.currentData.customer.wallet_notify_url;
        }
      }
      let sendData = {};
      if (data.agent) {
        data.system_rate = data.agent.system_rate_f;
        data.p_times = data.agent.p_times;
        data.user_name_time = data.agent.user_name_time;
        data.user_name_enable = data.agent.user_name_enable;
      }
      Object.keys(data).forEach(e => {
        if (data[e] !== "" && e != "currency") {
          sendData[e] = data[e];
        }
      });
      let send = true;
      if (sendData.role_name == "agent") {
        let arr = [];
        if (sendData.c_p_times_ignore != "" && sendData.c_p_times_ignore) {
          sendData.c_p_times_ignore.split("\n").forEach(num => {
            if (num.length != 0 && !Number(num)) {
              send = false;
              // this.$store.dispatch("modal/modalContent", "");
              return;
            }
            if (num != "") {
              arr.push(num.trim());
            }
          });
        }
        sendData.p_times_ignore = arr;
      }
      if (sendData.customer) {
        delete sendData.customer;
      }
      if (!send) return;
      delete sendData.c_p_times_ignore;
      this.$http
        .put(`/back/users/${this.currentData.id}`, sendData)
        .then(res => {
          if (res.data.code == 0) {
            this.editUserModal = false;
            this.currentData = {};
            this.$message.success("成功");
          }
        });
    },
    editUser(user) {
      let data = JSON.parse(JSON.stringify(user));
      if (data.role_name == "agent") {
        if (data.agent.p_times_ignore) {
          data.c_p_times_ignore = data.agent.p_times_ignore
            .join()
            .replace(/,/g, "\n");
        } else {
          data.c_p_times_ignore = "";
        }
      }
      if (data.role_name == "customer") {
        if (!data.customer.limit_start_time)
          data.customer.limit_start_time = "00:00";
        if (!data.customer.limit_end_time)
          data.customer.limit_end_time = "00:00";
      }
      this.currentData = JSON.parse(JSON.stringify(data));
      this.activeName = "1";
      this.editUserModal = true;
    },
    confirmEditPassword() {
      let data = this.editPasswordData;
      data.oneCode = this.oneCode;
      data.user_id = this.currentData.id;
      data.role_name = this.currentData.role_name;
      this.$http.put(`/back/users/${this.currentData.id}`, data).then(res => {
        if (res.data.code == 0) {
          this.editPasswordModal = false;
          this.$message.success("成功");
        }
      });
    },
    editPassword(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.editPasswordModal = true;
      this.editPasswordData = {};
      this.oneCode = "";
    },
    confirmReset2FA() {
      this.$http
        .post(`/back/users/reset2FA/${this.currentData.id}`, {
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.reset2FAModal = false;
          }
        });
    },
    reset2FA(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.reset2FAModal = true;
      this.oneCode = "";
    },
    confirmEditSwitch() {
      let changeData = {};
      changeData[this.currentData.assign] =
        this.currentData[this.currentData.assign] == 1 ? 0 : 1;
      this.$http.post(this.currentData.api, changeData).then(res => {
        if (res.data.code == 0) {
          this.editSwitchModal = false;
          this.getData();
        }
      });
    },
    changeSwitch(user, assign, title, api) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.currentData.assign = assign;
      this.currentData.api = api;
      this.switchData.editTitle = title;
      this.editSwitchModal = true;
      if (this.currentData.role_name == "customer" && title != "啟用狀態") {
        this.currentData[assign] = this.currentData.customer[assign];
      }
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      searchData.status = 0;
      this.$http
        .get(`/back/users/staff/sub`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.labelGroup {
  margin-top: 30px;
}
.labelChildren {
  margin-left: 20px;
  margin-top: 10px;
  .children {
    margin-top: 10px;
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    .lastBox {
      margin: 5px;
    }
  }
}
h2 {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 26px;
  em {
    font-size: 48px;
    color: white;
    margin-right: 20px;
  }
}
.btnGroup {
  display: flex;
  justify-content: center;
}
</style>
